import { render, staticRenderFns } from "./setDialog.vue?vue&type=template&id=5c7f50ac&scoped=true&"
import script from "./setDialog.vue?vue&type=script&lang=js&"
export * from "./setDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDialog.vue?vue&type=style&index=0&id=5c7f50ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f50ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7f50ac')) {
      api.createRecord('5c7f50ac', component.options)
    } else {
      api.reload('5c7f50ac', component.options)
    }
    module.hot.accept("./setDialog.vue?vue&type=template&id=5c7f50ac&scoped=true&", function () {
      api.rerender('5c7f50ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/components/setDialog.vue"
export default component.exports